import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentUser } from "../../common/providers/current-user";
import { EvaluationAthleteProvider } from '../../evaluation-athlete/providers/evaluation-athlete-provider.services';
import { ArrayUtils } from '../../common/providers/array-utils';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EvaluationAthleteQuestionProvider } from '../../evaluation-athlete/providers/evaluation-athlete-question-provider.services';
import { EvaluationAthleteAnswerProvider } from '../../evaluation-athlete/providers/evaluation-athlete-answer-provider.services';
import { CoachesProvider } from '../../coaches/providers/coaches-provider';
import { ConfigProvider } from "../../config-provider.service";
import { Title } from '@angular/platform-browser';
import { CurrentUserRolesProvider } from '../../organizations/providers/current-user-roles-provider';
import { forkJoin, map, Observable, Subscription } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MobileHeaderComponent } from "../../common/components/mobile-header/mobile.header";
import { MobileSideMenuComponent } from "../../common/components/mobile-side-menu/mobile.side-menu.component";
import { Error401Component } from "../../common/components/error-401/error-401";
import { Error404Component } from "../../common/components/error-404/error-404";
import { MatCardHeader, MatCardModule } from "@angular/material/card";
import { MatChip, MatChipsModule } from "@angular/material/chips";
import {
  EvaluationAthleteQuestionGroupComponent
} from "../../evaluation-athlete/components/question-group/evaluation-athlete-question-group";
import { FlexLayoutModule } from "@angular/flex-layout";
import { AppDatePipe } from "../../common/pipes/app-date";
import { MobileModuleContentComponent } from "../../common/components/mobile-module-content/mobile-module-content";
import { NgIf } from "@angular/common";
import { MobilePageContentComponent } from "../../common/components/mobile-page-content/mobile-page-content";
import { EvaluationAthlete } from "../../common/models/evaluation-athlete";
import { Athlete } from "../../common/models/athlete";
import { Organization } from "../../common/models/organization";
import { User } from "../../common/models/user";
import { Question } from "../../common/models/question";
import { Answer } from "../../common/models/answer";
import { Coach } from "../../common/models/coach";
import { HasPendingChangesGuard } from "../../common/guards/has-pending-changes";
import { MatFormField } from "@angular/material/form-field";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import { MatInput, MatInputModule } from "@angular/material/input";
import { MainActionComponent } from "../../common/components/main-action/main-action";
import { MatButton } from "@angular/material/button";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { ConfirmDialogComponent } from "../../common/components/confirm-dialog/confirm-dialog";

@Component({
  selector: 'app-mobile-evaluation-edit',
  templateUrl: './mobile.evaluation.edit.component.html',
  styleUrls: ['./mobile.evaluation.edit.component.scss'],
  imports: [
    MobileHeaderComponent,
    MobileSideMenuComponent,
    Error401Component,
    Error404Component,
    MatCardModule,
    MatChipsModule,
    EvaluationAthleteQuestionGroupComponent,
    FlexLayoutModule,
    ReactiveFormsModule,
    TranslateModule,
    AppDatePipe,
    MobileModuleContentComponent,
    NgIf,
    MobilePageContentComponent,
    MatFormField,
    CdkTextareaAutosize,
    MatInputModule,
    MainActionComponent,
    MatButton
  ],
  standalone: true
})
export class MobileEvaluationEditComponent implements OnInit, OnDestroy {

    public readonly NOTES_MAX_LENGTH: number = 5000;

    public pageTitle = 'EvaluationAthleteList';
    public isLoading = true;
    public is401 = false;
    public is404 = false;
    public isDesktop = false;

    public organization: Organization = {} as Organization;
    public athleteUser: User = {} as User;
    public evaluationAthlete: any | EvaluationAthlete = {}  as EvaluationAthlete;
    public questions: Question[] = [];
    public answers: Answer[] = [];
    public currentEvaluationType = '';

    public isSubmitting = false;
    public evaluationForm: FormGroup;

    public questionsGrouped: any = [];

    @ViewChild(MatPaginator, {static: false}) public paginator: MatPaginator | undefined;

    private coach: Coach = {} as Coach;
    private subscriptions: Subscription[] = [];

    constructor(
        public conf: ConfigProvider,
        private title: Title,
        public _changesGuard: HasPendingChangesGuard,
        private currentUser: CurrentUser,
        private currentUserRoles: CurrentUserRolesProvider,
        private datePipe: AppDatePipe,
        private route: ActivatedRoute,
        private evaluationAthleteProvider: EvaluationAthleteProvider,
        private arrayUtils: ArrayUtils,
        private fb: FormBuilder,
        private utils: UtilsProvider,
        private toaster: MatSnackBar,
        private translator: TranslateService,
        private router: Router,
        private questionProvider: EvaluationAthleteQuestionProvider,
        private answerProvider: EvaluationAthleteAnswerProvider,
        private coachProvider: CoachesProvider,
        private dialog: MatDialog,
        private api: ApiBaseService,
    ) {
        this.evaluationForm = this.fb.group({
            id: new FormControl(null),
            athleteUserId: new FormControl(null),
            coachUserId: new FormControl(null),
            evaluationAthleteId: new FormControl(null),
            questionsAthlete: this.fb.array([]),
            questionsCoach: this.fb.array([]),
            notes: new FormControl(null),
        });
    }

    @HostListener('window:beforeunload')
    public doSomething() {
        return !this._changesGuard.hasChanges();
    }

    public ngOnInit() {
        // Load athlete and annual plan if it exists
        this.subscriptions.push(
            this.route.data.subscribe((data: any) => { //  { organization: Organization; athlete: Athlete; evaluationAthlete: EvaluationAthlete }
                if (data.organization) {
                    this.organization = data.organization;
                }

                if (data.athlete) {
                    this.athleteUser = data.athlete;
                }

                if (data.evaluationAthlete) {
                    this.evaluationAthlete = data.evaluationAthlete;
                    this.currentEvaluationType = data.evaluationAthlete['evaluation'].type;
                }

                this.loadData();
            })
        );

        this.answerProvider.findByEvaluationAthlete(this.evaluationAthlete).then((answers) => {
            this.answers = answers;
        });
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public loadData() {

        if (this.evaluationAthlete && !this.evaluationAthlete['rights'].edit) {
            this.is401 = true;
            return;
        }

        forkJoin([
          this.questionProvider.findByEvaluationAthleteId(this.organization.id!, this.evaluationAthlete.id),
          this.coachProvider.get(this.organization.id!, this.currentUser.user!.id!)
        ]).pipe(
          map(([questions, coachUser]) => {
            this.questionsGrouped = this.arrayUtils.groupByAttribute(questions, 'category', 'name');

            this.evaluationForm.get('coachUserId')?.setValue(coachUser.id);
            this.evaluationForm.get('id')?.setValue(this.evaluationAthlete.id);
            this.evaluationForm.get('athleteUserId')?.setValue(this.athleteUser.id);
            this.evaluationForm.get('notes')?.setValue(this.evaluationAthlete.notes);
            this.evaluationForm.get('evaluationAthleteId')?.setValue(this.evaluationAthlete.id);
          }),
        ).subscribe({
          next: () => {
            this.createForm();
            this.createPageTitle();
            this.isLoading = false;
          },
        });
    }

    public submitForm(): Observable<any> {
      return this.evaluationAthleteProvider.update(this.organization, this.evaluationForm.value).pipe(r => r)
    }

    public onFormChanged(): void {
        this._changesGuard.registerChanges(() => this.onSaveClicked());
    }

    public onSaveClicked(): any {
        if (this.evaluationForm.valid) {
            this.isSubmitting = true;
            // this.isLoading = true;
            this.submitForm()
                .subscribe({
                    next: (data) => {
                        this.toaster.open(this.translator.instant('Evaluation_Saved'), '', { duration: 5000 });
                        this.isSubmitting = false;
                        // this.isLoading = false;
                        this._changesGuard.unregisterChanges();
                        return true;
                    },
                    error: (error) => {
                        return false;
                    }
                });
        } else {
            this.utils.validateAllFormFields(this.evaluationForm);
            this.isSubmitting = false;
            this.isLoading = false;
           return false;
        }
    }

    public closeEvaluation() {
        const dialog: MatDialogRef<any> = this.dialog.open(ConfirmDialogComponent, {
            data: {
                confirmText: this.translator.instant('Confirm_Close_Evaluation'),
                confirmActionText: this.translator.instant('Close'),
                color: 'accent'
            }
        });

        this.subscriptions.push(
            dialog.afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                    this.isSubmitting = true;

                    if (this.evaluationForm.valid) {
                        if (this._changesGuard.hasChanges()) {
                            this.evaluationAthleteProvider.update(this.organization, this.evaluationForm.value).subscribe(() => {
                                this._changesGuard.unregisterChanges();
                            });
                        }

                        this.evaluationAthleteProvider.closeEvaluation(this.organization, this.evaluationForm.value).subscribe({
                          next: () => {
                            this.toaster.open(this.translator.instant('Evaluation_Closed'), '', { duration: 5000 });

                            this.router.navigate([this.organization!.code + '/app/athletes/' + this.athleteUser.id + '/evaluations/' + this.evaluationAthlete.id]);
                          }
                        });
                    } else {
                        this.utils.validateAllFormFields(this.evaluationForm);
                        this.isSubmitting = false;
                    }
                }
            })
        );
    }

    private createPageTitle() {
        this.pageTitle = this.translator.instant('EvaluationOf', { date: this.datePipe.transform(this.evaluationAthlete.date, 'mediumDate') });
        this.title.setTitle(this.pageTitle + ' | ' + this.conf.platformName);
    }

    private createForm() {
        for (const type of Object.keys(this.questionsGrouped)) {
            for (const question of this.questionsGrouped[type]) {
                this.addAthleteQuestionToForm(question);
                this.addCoachQuestionToForm(question);
            }
        }
    }

    private addAthleteQuestionToForm(question: Question) {
        const value = this.arrayUtils.findAnswerByQuestionIdAthleteId(this.answers, question.id!, this.athleteUser.athlete?.id!);

        const questions = this.evaluationForm.get('questionsAthlete') as FormArray;
        const formGroup = this.fb.group({
            id: new FormControl(question.id),
            question: new FormControl(question),
            answer: new FormControl(value),
        });

        questions.push(formGroup);
    }

    private addCoachQuestionToForm(question: Question) {

        if (this.coach) {
            const value = this.arrayUtils.findAnswerByQuestionIdCoachId(this.answers, question.id!, this.coach.id!);

            const questions = this.evaluationForm.get('questionsCoach') as FormArray;
            const formGroup = this.fb.group({
                id: new FormControl(question.id),
                question: new FormControl(question),
                answer: new FormControl(value),
            });

            questions.push(formGroup);
        }
    }
}
